/* Lookbook: de + schuift de producten uit de foto omhoog (WOO-678).
   Desktop: paneel in de foto. Mobiel: dezelfde lijst onderin het scherm. */
(() => {
  if (window.lookbookProductsReady) return;
  window.lookbookProductsReady = true;

  const mobile = window.matchMedia('(max-width: 899px)');
  let activeToggle = null;
  let sheet = null;
  let backdrop = null;

  const ensureSheet = () => {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'wt-lookbook__backdrop';
    sheet = document.createElement('div');
    sheet.className = 'wt-lookbook__sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-hidden', 'true');
    const labelSource = document.querySelector('[data-close-label]');
    sheet.innerHTML =
      '<div class="wt-lookbook__sheet-head"><div class="wt-lookbook__products-head"></div>' +
      '<button type="button" class="wt-lookbook__sheet-close"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg></button></div>' +
      '<div class="wt-lookbook__sheet-body"></div>';
    sheet.querySelector('.wt-lookbook__sheet-close').setAttribute('aria-label', (labelSource && labelSource.dataset.closeLabel) || 'Close');
    sheet.querySelector('.wt-lookbook__sheet-close').addEventListener('click', () => close(true));
    backdrop.addEventListener('click', () => close(true));
    document.body.append(backdrop, sheet);
  };

  const setLinksFocusable = (panel, focusable) => {
    panel.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', focusable ? '0' : '-1'));
  };

  const close = (returnFocus = false) => {
    if (!activeToggle) return;
    const toggle = activeToggle;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    toggle.closest('.wt-lookbook__link--products').classList.remove('is-open');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      setLinksFocusable(panel, false);
    }
    if (sheet) {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-open');
    }
    activeToggle = null;
    if (returnFocus) toggle.focus();
  };

  const open = (toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    activeToggle = toggle;
    toggle.setAttribute('aria-expanded', 'true');

    if (mobile.matches) {
      ensureSheet();
      sheet.querySelector('.wt-lookbook__products-head').textContent = panel.querySelector('.wt-lookbook__products-head').textContent;
      const body = sheet.querySelector('.wt-lookbook__sheet-body');
      body.innerHTML = '';
      body.append(panel.querySelector('.wt-lookbook__products-list').cloneNode(true));
      setLinksFocusable(body, true);
      sheet.setAttribute('aria-hidden', 'false');
      // Eerst de dichte stand laten berekenen, dan openen, zodat de lijst omhoog schuift
      void sheet.offsetHeight;
      requestAnimationFrame(() => {
        backdrop.classList.add('is-open');
        sheet.classList.add('is-open');
        sheet.querySelector('.wt-lookbook__sheet-close').focus({ preventScroll: true });
      });
    } else {
      toggle.closest('.wt-lookbook__link--products').classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      setLinksFocusable(panel, true);
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.wt-lookbook__toggle');
    if (toggle) {
      event.preventDefault();
      const wasOpen = toggle === activeToggle;
      close();
      if (!wasOpen) open(toggle);
      return;
    }
    if (activeToggle && !event.target.closest('.wt-lookbook__products, .wt-lookbook__sheet')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close(true);
  });

  mobile.addEventListener('change', () => close());
})();
